import { render, staticRenderFns } from "./tournaments.vue?vue&type=template&id=7fe90e1d&"
import script from "./tournaments.vue?vue&type=script&lang=js&"
export * from "./tournaments.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports